import { type JSX, type RefObject } from 'react';

interface EmailInputProps {
    inputRef: RefObject<HTMLInputElement>;
    error: string | undefined;
    touched: boolean;
    disabled: boolean;
    isCheckingSSO: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus: () => void;
    onBlur: () => void;
}

export function EmailInput({
    inputRef,
    error,
    touched,
    disabled,
    isCheckingSSO,
    onChange,
    onFocus,
    onBlur,
}: EmailInputProps): JSX.Element {
    const hasError = touched && error;
    return (
        <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-1">
                Email
            </label>
            <input
                ref={inputRef}
                id="email"
                type="email"
                name="email"
                required
                placeholder="Enter your email"
                autoComplete="email"
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                disabled={disabled}
                className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 placeholder:text-gray-700 ${
                    hasError ? 'border-red-500' : 'border-gray-700'
                } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            />
            {hasError && <div className="mt-1 text-sm text-red-600">{error}</div>}
            {isCheckingSSO && <div className="mt-1 text-sm text-gray-600">Checking organization...</div>}
        </div>
    );
}
